import { useMemo } from 'react';
import { ExportEpisodeTextParser } from '../../../../services/ExportEpisodeText/ExportEpisodeTextParser';
import { ExportEpisodeJson } from '../../../../services/ExportEpisodeText/types/ExportEpisodeTextTypes';

/**
 * React hook for exporting episode data to formatted text
 * @param episodeJson The episode JSON data to export
 * @returns Formatted text representation of the episode
 */
export const useEpisodeTextExporter = (episodeJson: ExportEpisodeJson | null) => useMemo(() => {
  if (!episodeJson) {
    return null;
  }
  const parser = new ExportEpisodeTextParser(episodeJson);
  const text = parser.toText();
  if (!text || text === '') {
    return null;
  }
  return `// Node/Character\tText/Commands\tCommands\n${text}`;
}, [episodeJson]);
